import { toast } from 'react-toastify';
import appApi from '../../../../../../api/app-api';
import globalSettingsStores from '../../../../../../stores/settings-stores';
import { displayErrorText } from '../../../../../../api/errors/api-error-codes';

export const deleteDocTypeOperation = async (
  docTypeId: number,
  setDocTypeId: (docTypeId: number | null) => void,
) => {
  try {
    setDocTypeId(docTypeId);

    const res = await appApi.deleteDocType(docTypeId);
    if (res.data.ok) {
      await globalSettingsStores.fetchSetting();
    } else if (res.data.errCode) {
      toast.warn(displayErrorText(res.data.errCode));
    }
    setDocTypeId(null);
  } catch (e) {
    setDocTypeId(null);
    console.error(
      `deleteDocTypeOperation failed with the docTypeId: ${docTypeId}, and the error: ${e}`,
    );
    toast.error(`משהו קרה, נסה שוב בעוד מספר רגעים...`);
  }
};
